import { render, staticRenderFns } from "../../assets/templates/AccessType/AccessType.html?vue&type=template&id=39ed78f2&scoped=true&"
import script from "../../assets/scripts/AccessType/AccessType.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/AccessType/AccessType.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/accessType.scss?vue&type=style&index=0&id=39ed78f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed78f2",
  null
  
)

export default component.exports